import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import cartConfig from "emun.cart/cart.config";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import resolve from "ioc/resolve";
import csvParser from 'webutils/services/csv-json';

export default class OrderImportItemsController {
	constructor($rootScope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.config = cartConfig;
		$ctrl.title = options.title || "Import item(s)";
		$ctrl.results = [];
		$ctrl.parts = [];
	}

	save() {
		const $ctrl = this;
		$ctrl.lines = [];
		$ctrl.bus.validationErrors = [];


		let result = $ctrl.results.reduce((accumulatorPromise, part) => {
			return accumulatorPromise.then(() => {
				if (part.qty > 0) {
					var item = part.isInCart() ? $ctrl.$cart.itemIndex[part.id] : {};
					item.qtyPurchased = item.quantity = part.qty;
					item.notes = part.notes;
					item.shipOn = part.shipOn;
					if (part.priceOverride !== part.price) {
						item.priceOverride = part.priceOverride;
					}
					return part.isInCart() ? $ctrl.$cart.changeOptions(item, part) : $ctrl.$cart.addItem(item, part, true, '', true);
				}
			});
    }, Promise.resolve());
    result.then(() => {
      //console.info("Multi Import Add Done");
      $ctrl.$cart.load();
      $ctrl.$close();
    });

		//$ctrl.results.forEach(function (part, index) {
		//	if (part.qty > 0) {
		//		var item = {};
		//		item.qtyPurchased = item.quantity = part.qty;
		//		item.notes = part.notes;
		//		if (part.priceOverride !== part.price) {
		//			item.priceOverride = part.priceOverride;
		//		}
		//		//part.cartStatus = "processing";
				
		//		//setTimeout(function () {
		//		//	$ctrl.$cart.addItem(item, part, true).then(() => {
		//		//		part.cartStatus = "success";
		//		//	}, () => {
		//		//		part.cartStatus = "failed";
		//		//	});
		//		//}, 1000 * index);

		//		//item.product = part;
		//		//$ctrl.lines.push(item);
		//	}
		//});

		//if ($ctrl.lines.length > 0) {
		//	$ctrl.$cart.addMultipleItems($ctrl.lines).then(() => {
		//		$ctrl.$cart.load($ctrl.$cart.id);
		//		$ctrl.$close();
		//	});
		//}
	}

	processText(text) {
		let $ctrl = this;

		var content = {
			csv: text.replace(/\r\n|\r/g, "\n"),
			header: false,
			separator: ","
		};
		$ctrl.content = content.csv;
		var lines = content.csv.split(
			new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
		);
		var columncount = lines[0].split(content.separator).length;

		var header = "id\r\n";
		if (columncount > 1) header = "id,qty\r\n";

		text = header + text;
		$ctrl.finished = false;
		$ctrl.parts = [];


		$ctrl.parts = csvParser.parse(text);
		//console.debug("parts", $ctrl.parts);
		//console.debug("text", text);
		$ctrl.finished = false;
		resolve('$rootScope').$apply();
	}

}
